const ENABLED_ENVIRONMENTS = ['production', 'staging'];
const PIXEL_ID = '345298259811508';

/**
 * Facebook pixel. Only the `fbq` command queue is set up here; fbevents.js
 * itself is a consent-gated tag in public/index.html that OneTrust activates
 * once the visitor opts in, and it drains this queue when it loads. Nothing
 * is sent before consent.
 */
const FacebookTracker = {
  initialize() {
    if (!ENABLED_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT)) {
      return;
    }
    if (window.fbq) return;

    const fbq = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  },
  track() {
    if (!ENABLED_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) || !window.fbq) {
      return;
    }

    window.fbq('track', 'PageView');
  },
};

export default FacebookTracker;
